import { createClient } from '@supabase/supabase-js';
import { Preferences } from '@capacitor/preferences';
import { isNative } from './platform';

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL;
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY;

// iOS can clear a web view's localStorage under storage pressure, which would
// sign users out at random. In the app, keep the session in native storage.
const nativeStorage = {
  getItem: async (key) => (await Preferences.get({ key })).value,
  setItem: (key, value) => Preferences.set({ key, value }),
  removeItem: (key) => Preferences.remove({ key }),
};

export const supabase = createClient(supabaseUrl, supabaseAnonKey, isNative
  ? { auth: { storage: nativeStorage } }
  : undefined);
